<template>
	<div class="key-result-list">
		<NewKeyResultForm
			v-for="( form, index ) in keyResultForms"
			:confidence-level="form.confidenceLevel"
			:current-value="form.currentValue"
			:data-scrolltarget="true"
			:disabled="disabled"
			:end-date="form.endDate"
			:errors="form.errors"
			:focused-field="focusedField"
			:form-id="form.formId"
			:key="form.formId"
			:name="form.name"
			:number="index + 1"
			:owner-id="form.ownerId"
			:parent-goal-name="form.parentGoalName"
			:possible-key-result-owners="possibleKeyResultOwners"
			:start-date="form.startDate"
			:start-value="form.startValue"
			:target-value="form.targetValue"
			:type="form.type"
			@discard="onPromptToDiscard( form.formId, $event )"
			@focusChange="$emit( `focusChange`, $event )"
			@formChange="$emit( `formChange`, $event )"
		/>
	</div>
</template>

<script>
import { FormMixin } from "@teaming/common-ui";
import NewKeyResultForm from "./NewKeyResultForm";

/** @deprecated - KRs are now created AFTER a goal is created */
export default {
	name: "NewKeyResultList",
	// NOTE: this is not technically a form, but its API is a proxy
	// for the *current form* being edited, so it can use FormMixin
	mixins: [ FormMixin, ],
	emits: [ "discard", ],
	components: {
		NewKeyResultForm,
	},
	props: {
		keyResultForms: {
			type: Array,
			required: true,
		},
		possibleKeyResultOwners: {
			type: Array,
			required: true,
		},
	},
	methods: {
		onPromptToDiscard( formId ) {
			this.formIdToDiscard = formId;
			this.$emit( "discard", formId );
		},
	},
};
</script>

<style lang="scss" scoped>
.key-result-list {
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	gap: 2rem;
}
</style>
